import React from "react";
import CompareOriginalVsCompressed from "components/features/CompressorCommon/CompareOriginalVsCompressed";

import JpegCompressorFaq from "components/features/JpegCompressor/JpegCompressorFaq";
import JpegCompressorForEveryOne from "components/features/JpegCompressor/JpegCompressorForEveryOne";
import { WeSupportBulkImageCompressionSection } from "components/features/CompressorCommon/WeSupportBulkImageCompressionSection";

const JpegCompressorPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-4  md:mx-20">
                <CompareOriginalVsCompressed
                    originalSizeInKb={417}
                    compressedSizeInKb={99}
                    imageSrc1="/images/original_vs_compressed_src.jpeg"
                    imageSrc2="/images/original_vs_compressed_dest.jpeg"
                />
                <WeSupportBulkImageCompressionSection />
                <JpegCompressorForEveryOne />
                <JpegCompressorFaq />
            </div>
        </div>
    );
};

export default JpegCompressorPreToolsArea;
